import { render } from "./startCompliance.vue?vue&type=template&id=22cec72f&scoped=true&ts=true"
import script from "./startCompliance.vue?vue&type=script&lang=ts"
export * from "./startCompliance.vue?vue&type=script&lang=ts"

import "./startCompliance.vue?vue&type=style&index=0&id=22cec72f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cec72f"]])

export default __exports__